module.exports = __webpack_public_path__ + "static/img/ms.8575cf8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/ms.png
// module id = Sxj9
// module chunks = 1